/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Download_Over_WifiInputs */

const en_mobile_download_over_wifi = /** @type {(inputs: Mobile_Download_Over_WifiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download over WiFi`)
};

const es_mobile_download_over_wifi = /** @type {(inputs: Mobile_Download_Over_WifiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descargar por WiFi`)
};

/**
* | output |
* | --- |
* | "Download over WiFi" |
*
* @param {Mobile_Download_Over_WifiInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_download_over_wifi = /** @type {((inputs?: Mobile_Download_Over_WifiInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Download_Over_WifiInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_download_over_wifi(inputs)
	return en_mobile_download_over_wifi(inputs)
});